<template>
  <div class="flex justify-end">
    <select-sort
      v-model="sort"
      class="<md:w-full"
      :label="$t.sort"
      :options="sortOptions"
    />
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  sortOptions: Array<{ value: string, label: string }>
}>()

const sort = defineModel<string>()
</script>
